<template>
    <div class="flex-grow-1 overflow-auto">
      <div class="d-flex justify-content-center flex-column py-3 px-5">
        <div v-if="options.qrcode != null" class="mb-3">
          <VueQrcode class="w-100" tag="img" :value="options.qrcode.value" :options="options.qrcode" />
        </div>
        <div v-if="options.barcode != null" class="mb-3">
          <VueBarcode class="w-100" tag="svg" :value="options.barcode.value" :options="options.barcode" />
        </div>
      </div>
    </div>
</template>
<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueBarcode from '@chenfengyuan/vue-barcode';

export default {
  name: 'McfGiftQrcodeMobile',
  props: {
    options: {
      type: Object,
    },
  },
  components: {
    VueQrcode,
    VueBarcode,
  },
  data() {
    return {};
  },
};
</script>
